import request from '../../requests/requests';
import { Api } from '../../config/api';
import { configs } from '../../config/config';


export function getDeviceFinance(data){
    return request({
        url:Api.device_finance.info+data.id,
        method:configs.http.request.methodGet,
        data
    })
}


export function updateNextPayDl(data){
    return request({
        url:Api.device_finance.update,
        method:configs.http.request.methodPost,
        data
    })
}

export function showReminder(data){
    return request({
        url:Api.device_finance.reminder,
        method:configs.http.request.methodPost,
        data
    })
}

export function stopShowReminder(data){
    return request({
        url:Api.device_finance.stop_reminder,
        method:configs.http.request.methodPost,
        data
    })
}


export function setDueDate(data){
    return request({
        url:Api.device_finance.set_duedate,
        method:configs.http.request.methodPost,
        data
    })
}

export function clearConflictTestData(data){
    return request({
        url:Api.device_finance.clear_conflict,
        method:configs.http.request.methodPost,
        data
    })
}
export function setPermanentUnlock(data){
    return request({
        url:Api.device_finance.set_permanent,
        method:configs.http.request.methodPost,
        data
    })
}
